module.exports = __webpack_public_path__ + "media/images/icons/heart-06da6cbc7907be4ae028daa6d71cec00.svg";